import { useEffect, useMemo, useState } from 'react';
import styles from './chartByStatus.module.scss';
import { ChartByStatusDashboardProps } from '../../../../interfaces/components';
import { useToast } from '../../../../helpers/hooks';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { IconButton, Skeleton } from '@mui/material';
import { optionsByStatusProps } from '../../../../interfaces';
import { PUBLICATIONS_DROPDOWN_TEXTS, TRANSACTIONS_DROPDOWN_TEXTS, PUBLICATION_STATUS_LABELS, TRANSACTIONS_STATUS_LABELS } from '../../../../constants/dashboard';
import ToolTip from '../../../../components/ToolTip/ToolTip';

const ChartByStatus = ({
    user,
    branch,
    getStatusPublications,
    cleanStatusPublications,
    getStatusTransactions,
    cleanStatusTransactions,
    status,
    date,
    className = undefined
}: ChartByStatusDashboardProps) => {
    const toast = useToast();
    const [section, setSection] = useState<string>("publication");

    const barChart = (chart: any, index: number) => {
        return <div className={styles.barChart} key={index}>
            {
                (status?.transactions?.fetching === "loading" || status?.publications?.fetching === "loading")
                ?   <Skeleton animation="wave" variant="rounded" className={`${styles.skeleton} ${styles.name}`} />
                :
                    <div className={styles.header}>
                        <div className={styles.name}>
                            <p>{section === "publication" ? PUBLICATION_STATUS_LABELS[chart?.status]?.label : TRANSACTIONS_STATUS_LABELS[chart?.status]?.label}</p>
                            <ToolTip className={styles.tooltip}>
                                <div className={styles.item}>
                                    <p className={styles.title}>{section === "publication" ? PUBLICATION_STATUS_LABELS[chart?.status]?.label : TRANSACTIONS_STATUS_LABELS[chart?.status]?.label}</p>
                                    <hr className={styles.line} />
                                    <p className={styles.text}>{section === "publication" ? PUBLICATIONS_DROPDOWN_TEXTS[chart?.status] : TRANSACTIONS_DROPDOWN_TEXTS[chart?.status]}</p>
                                </div>
                            </ToolTip>
                        </div>
                        <p className={styles.value}>{chart?.percent}%</p>
                    </div>
                    
            }
            {
                (status?.transactions?.fetching === "loading" || status?.publications?.fetching === "loading")
                ?   <Skeleton animation="wave" variant="rounded" className={styles.bar} />
                :
                    <div className={styles.bar}>
                        <div className={styles.completed} style={{"width": chart?.percent + "%"}}></div>
                    </div>
            }
        </div>;
    }

    const optionsTransactions: optionsByStatusProps[] = useMemo(() => {
        let data = [
            {
                status: "pending",
                percent: 0,
            },
            {
                status: "in_progress",
                percent: 0,
            },
            {
                status: "finished",
                percent: 0,
            },
            {
                status: "cancelled",
                percent: 0,
            }
        ];
        if(status?.transactions?.data && status?.transactions?.data.length > 0) data = status?.transactions?.data;
        return data;
    }, [status?.transactions?.fetching, status?.transactions?.data]);

    const optionsPublications: optionsByStatusProps[] = useMemo(() => {
        let data = [
            {
                status: "published",
                percent: 0,
            },
            {
                status: "inspection",
                percent: 0,
            },
            {
                status: "match",
                percent: 0,
            },
            {
                status: "linze_visit",
                percent: 0,
            },
            {
                status: "payment",
                percent: 0,
            },
            {
                status: "documentation_signature",
                percent: 0,
            },
            {
                status: "delivered",
                percent: 0,
            },
            {
                status: "sold_out",
                percent: 0,
            },
            {
                status: "rejected",
                percent: 0,
            },
            {
                status: "pending",
                percent: 0,
            }
        ];
        if(status?.publications?.data && status?.publications?.data.length > 0) data = status?.publications?.data;
        return data;
    }, [status?.publications?.fetching, status?.publications?.data]);

    useEffect(() => {
        if(status?.transactions?.fetching === "failure"){
            if(status?.transactions?.error){
                toast("Ha ocurrido un error al mostrar los estados de las transacciones");
            }
            cleanStatusTransactions();
        }
        if(status?.transactions?.fetching === "success"){
            cleanStatusTransactions();
        }
    }, [status?.transactions?.fetching]);

    useEffect(() => {
        if(status?.publications?.fetching === "failure"){
            if(status?.publications?.error){
                toast("Ha ocurrido un error al mostrar los estados de las publicaciones");
            }
            cleanStatusPublications();
        }
        if(status?.publications?.fetching === "success"){
            cleanStatusPublications();
        }
    }, [status?.publications?.fetching]);
    
    useEffect(() => {
        if(!!date?.start.length && !!date?.end.length && (user?.branch || branch !== "")){
            getStatusPublications(date?.start, date?.end);
            getStatusTransactions(date?.start, date?.end);
        }
    }, [date, branch]);

    return(
        <div className={`${styles.byStatus} ${className}`}>
            <div className={styles.header}>
                <p className={styles.title}>
                    <span className={styles.label}>{`Estados de ${section === "publication" ? "publicación" : "transacción"}`}</span>
                </p>
                <div className={styles.arrows}>
                    <IconButton id="arrowLeft" className={`${styles.arrow} ${styles.left}`} disabled={section === "publication"} onClick={() => setSection("publication")}>
                        <ArrowBackIosNewIcon className={styles.icon} />
                    </IconButton>
                    <IconButton id="arrowRight" className={`${styles.arrow} ${styles.right}`} disabled={section === "transaction"} onClick={() => setSection("transaction")}>
                        <ArrowBackIosNewIcon className={styles.icon} />
                    </IconButton>
                </div>
            </div>
            <div className={styles.content}>
                {
                    section === "publication"
                    ?   optionsPublications && optionsPublications.map((item: any, index: number) => (
                            barChart(item, index)
                        ))
                    :   optionsTransactions && optionsTransactions.map((item: any, index: number) => (
                            barChart(item, index)
                        ))
                }
            </div>
        </div>
    )
}

export default ChartByStatus;